import CashMachine from '@/integrations/cashmachine/cashmachine'

export function minimizeApp() {
  const ipcRenderer = window.require('electron').ipcRenderer
  ipcRenderer?.invoke('window:minimize')
}

export async function closeApp() {
  if (CashMachine.isEnabled()) {
    await CashMachine.close()
  }
  const ipcRenderer = window.require('electron').ipcRenderer
  ipcRenderer?.invoke('window:close')
}
